import { APIProvider } from '@vis.gl/react-google-maps';
import type { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/Header';
import { runtimeConfig } from '@/constants';
import { useHostContext } from '@/context/HostContext.tsx';
import { partnerMetadata } from '@/services/PartnerMetadata.ts';
import { cn } from '@/utils';

const Layout: FC<PropsWithChildren> = ({ children }) => {
	const { isMiniCreatorMode, isOverlayMode, isPageMode } = useHostContext();
	const isVibeCreatorEnabled = partnerMetadata.isVibeCreatorFlowEnabled();
	return (
		<main
			className={cn(
				'w-full sm:h-full min-h-0 flex flex-col bg-[#FAFAFA] creator-theme',
				{
					'px-5 sm:px-6 md:px-8 xl:px-16': !isMiniCreatorMode,
					'!p-0 relative isolate': isMiniCreatorMode,
					'min-h-0': isOverlayMode,
					'min-h-svh': isPageMode,
					'bg-white': isVibeCreatorEnabled
				}
			)}
			id="mini-creator-container"
		>
			{!isMiniCreatorMode && <Header className="shrink-0 mb-5" />}
			<div className="flex-1 min-h-0 flex justify-center">
				<APIProvider apiKey={runtimeConfig.googleApiKey}>
					{runtimeConfig.isRemoteBuild ? children : <Outlet />}
				</APIProvider>
			</div>
		</main>
	);
};

export default Layout;
